$(function(){

	/**
    * FIXME WS hack to support sticky header in chromium < 91
    */
    function getChromeVersion () {     
	    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	    return raw ? parseInt(raw[2], 10) : false;
	}
        
	var isChromium = !!window.chrome;
	
	if(isChromium) {
		if(getChromeVersion() < 91) {
			$("table.sticky-header thead th").addClass("sticky");
		}
	}    

});